<template>
  <div class="user-preview">
    <div id="contents">
      <div class="inner clearfix detail-top">
        <p
          v-if="interview.companyName"
          class="mt10 fll hd-type-01 company-name"
          data-test="company-name"
        >
          {{ interview.companyName }}
        </p>
        <div class="clearfix" />
        <ul class="mt30 fs13 detail-menu">
          <a>
            <li data-test="tab-menu-job">募集情報</li>
          </a>
          <a>
            <li data-test="tab-menu-photo-clip">フォトクリップ</li>
          </a>
          <span>
            <li
              data-test="tab-menu-interview"
              class="active"
            >インタビュー記事</li>
          </span>
        </ul>
        <div
          v-if="interview.catchCopy"
          class="company-area"
        >
          <h1
            class="fs16 hd-type-02 company-title option-title"
            data-test="catch-copy"
          >
            {{ interview.catchCopy }}
          </h1>
        </div>
        <div class="contents-inner clearfix mb30">
          <section>
            <article>
              <div
                v-if="interview.image || interview.intervieweePosition || interview.intervieweeName || interview.intervieweeProfile"
                data-test="main-image-with-interviewee-area"
                class="clearfix mb25 pb10"
              >
                <figure
                  v-if="interview.image"
                  data-test="photo-main"
                  class="flr ml30 interview-top-img"
                >
                  <img
                    :src="getPhotoUrl(interview.image)"
                    data-test="photo-main-img"
                    class="flr ml30 interview-img-main"
                  >
                </figure>
                <div
                  v-if="interview.intervieweePosition || interview.intervieweeName || interview.intervieweeProfile"
                  data-test="interviewee-area"
                  class="tl profile fs13"
                >
                  <p
                    v-if="interview.intervieweePosition"
                    class="fwB"
                    data-test="position"
                  >
                    {{ interview.intervieweePosition }}
                  </p>
                  <p
                    v-if="interview.intervieweeName"
                    class="fwB fs15"
                    data-test="interviewee-name"
                  >
                    {{ interview.intervieweeName }}さん
                  </p>
                  <br v-if="interview.intervieweePosition || interview.intervieweeName">
                  <p
                    v-if="interview.intervieweeProfile"
                    class="pega-pre-wrap interviewee-profile"
                    data-test="profile"
                    v-text="interview.intervieweeProfile"
                  />
                </div>
              </div>
              <div class="details clearfix">
                <template v-for="(content, i) in interview.contentList">
                  <div
                    :key="i"
                    class="border_red interview-block pt30 pb30 plr20 clearfix"
                    :data-test="`content-${i}`"
                    :style="`background: url(${userImageUrlForPc}/option/interview/bg_stripe_gray.png) repeat top left;`"
                  >
                    <p
                      v-if="content.title"
                      class="mb15 fwB tc fs16 pega-pre-wrap"
                      :data-test="`title-${i}`"
                      v-text="content.title"
                    />
                    <div class="message-inner">
                      <figure
                        v-if="content.image || content.photoCaption"
                        :data-test="`photo-caption-area-${i}`"
                        class="fll mr20 block-figure"
                      >
                        <img
                          v-if="content.image"
                          :src="getPhotoUrl(content.image)"
                          :data-test="`photo-${i}`"
                          class="mb10 interview-img-sub"
                        >
                        <figcaption
                          v-if="content.photoCaption"
                          class="fs11 pega-pre-wrap"
                          :data-test="`caption-${i}`"
                          v-text="content.photoCaption"
                        />
                      </figure>
                      <p
                        v-if="content.text"
                        class="message p15 pega-pre-wrap"
                        :data-test="`text-${i}`"
                        v-text="content.text"
                      />
                    </div>
                  </div>
                </template>
              </div>
            </article>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/interview/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
export default {
  mixins: [jobPreviewCommon],
  props: {
    interview: {
      type: Object,
      required: true
    }
  }
}
</script>
